import React__default from 'react';
import Box from '../Box/Box.js';

/** Private component used to render placeholders in storybook and documentation examples  */
const Placeholder = ({
  width,
  height,
  id,
  label
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    id: id,
    sx: {
      width: width || '100%',
      height,
      display: 'grid',
      placeItems: 'center',
      bg: 'elevation.surface.sunken',
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'border.subtle'
    }
  }, label);
};
Placeholder.displayName = "Placeholder";
var Placeholder$1 = Placeholder;

export { Placeholder$1 as default };
